// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2cphv","upload":"Small_upload__XxpZZ","imageWrap":"Small_imageWrap__J0v0O","removeBtn":"Small_removeBtn__2_XtW"};